export default __webpack_public_path__ + "static/media/DTEX-UC3-Seq4-Report-PDF-Pg7.e25733c5.png";